import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PlanBadge } from "./PlanBadge";
import Sidebar from "./Sidebar";
import NotificationBell from "./NotificationBell";
import WhatsAppBubble from "./WhatsAppBubble";
import { 
  GitBranch, 
  LogOut,
  Search
} from "lucide-react";
import { Button } from "./ui/button";

export const DashboardLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-navy-50">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-30 bg-white/80 backdrop-blur-xl border-b border-navy-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          {/* Left side - Logo (visible on mobile) */}
          <div className="flex items-center gap-4 pl-12">
            <Link to="/dashboard" className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center">
                <GitBranch className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading text-xl font-bold text-navy-900 hidden sm:block">Divídelo</span>
            </Link>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-3">
            <NotificationBell />
            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-navy-50 rounded-full">
              <div className="w-7 h-7 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center">
                <span className="text-white font-semibold text-xs">{user?.name?.[0]}</span>
              </div>
              <span className="text-sm text-navy-700 font-medium">{user?.name?.split(' ')[0]}</span>
              <PlanBadge planType={user?.plan_type} size="small" />
            </div>
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleLogout}
              className="text-navy-500 hover:text-red-600 hover:bg-red-50"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-20 pb-12 px-4 sm:px-6 lg:pl-72">
        <div className="max-w-7xl mx-auto pl-8 sm:pl-0">
          {children}
        </div>
      </main>

      {/* WhatsApp Bubble - Solo para clientes */}
      {user?.role === 'client' && (
        <WhatsAppBubble 
          userName={user?.name || "Cliente"} 
          userEmail={user?.email || ""} 
        />
      )}
    </div>
  );
};

export default DashboardLayout;
